import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Attendance } from '../types/attendance';

const initialState: any = {
  meals: [],
  loading: false,
  error: null,
};

const mealSlice = createSlice({
  name: 'meals',
  initialState,
  reducers: {
    fetchmealsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchmealsSuccess: (state, action: PayloadAction<Attendance[]>) => {
      state.loading = false;
      state.meals = action.payload;
    },
    fetchmealsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    addmealstart: (state) => {
      state.loading = true;
      state.error = null;
    },
    addmealsuccess: (state, action: PayloadAction<Attendance>) => {
      state.loading = false;
      state.meals.push(action.payload);
    },
    addattendanceFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload; 
    },
    updatemealstart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updatemealsuccess: (state, action: PayloadAction<Attendance>) => {
      state.loading = false;
      state.meals = state.meals.map((attendance:any) =>
        attendance.id === action.payload.id ? action.payload : attendance
      );
    },
    updateattendanceFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    deletemealstart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deletemealsuccess: (state, action: PayloadAction<number>) => {
      state.loading = false;
      state.meals = state.meals.filter((attendance:any) => attendance.id !== action.payload);
    },
    deleteattendanceFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // No extra reducers needed since we are not using createAsyncThunk
  },
});

export const {
  fetchmealsStart,
  fetchmealsSuccess,
  fetchmealsFailure,
  addmealstart,
  addmealsuccess,
  addattendanceFailure,
  updatemealstart,
  updatemealsuccess,
  updateattendanceFailure,
  deletemealstart,
  deletemealsuccess,
  deleteattendanceFailure,
} = mealSlice.actions;

export default mealSlice.reducer;